<template>
  <vx-card
    title="Contact"
    class="mt-base"
  >
    <!-- OTEHR DATA -->

      <vs-input
        class="w-full"
        label="Phone"
        type="tel"
        v-model="data.phone"
      />

      <vs-input
        class="w-full mt-5"
        label="Email"
        type="email"
        v-model="data.email"
      />

      <vs-textarea class="mt-5" label="Address" v-model="data.address"/>

      <vs-input
        class="w-full mt-5"
        label="Website (https://example.com)"
        type="url"
        v-model="data.siteUrl"
      />

  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
